import { render, staticRenderFns } from "./ModalUniqueNumber.vue?vue&type=template&id=64a6b32c&"
import script from "./ModalUniqueNumber.vue?vue&type=script&lang=js&"
export * from "./ModalUniqueNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports